import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";
import { getCategoryName } from "@/mocks/articles";

type ArticleCardProps = {
  article: Article;
  layout?: "vertical" | "horizontal";
};

export default function ArticleCard({ article, layout = "vertical" }: ArticleCardProps) {
  const isHorizontal = layout === "horizontal";
  return (
    <article
      className={`group bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors ${
        isHorizontal ? "flex flex-col sm:flex-row" : "flex flex-col h-full"
      }`}
    >
      <Link
        to={`/article/${article.slug}`}
        className={`relative block overflow-hidden bg-background-200 ${
          isHorizontal ? "w-full sm:w-56 shrink-0 h-44 sm:h-auto" : "w-full h-48"
        }`}
        aria-label={article.title}
      >
        <img
          src={article.cover}
          alt={`${article.title} — 诱惑吃瓜娱乐话题配图`}
          title={`${article.title} 截图与配图`}
          className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-foreground-950/70 text-background-50 text-[11px] backdrop-blur-sm">
          {getCategoryName(article.categoryId)}
        </span>
      </Link>

      <div className={`flex flex-col flex-1 ${isHorizontal ? "p-4 md:p-5" : "p-4 md:p-5"}`}>
        <h3 className="text-base md:text-lg font-semibold text-foreground-950 leading-snug">
          <Link to={`/article/${article.slug}`} className="hover:text-primary-600 transition-colors">
            {article.title}
          </Link>
        </h3>
        <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">{article.excerpt}</p>

        <div className="mt-auto pt-4 flex items-center justify-between text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-user-3-line w-4 h-4 flex items-center justify-center"></i>
            {article.author}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line w-4 h-4 flex items-center justify-center"></i>
              {(article.views / 1000).toFixed(1)}k
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-chat-3-line w-4 h-4 flex items-center justify-center"></i>
              {article.comments}
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}